<template>
  <General />
</template>

<script>
import General from "../../components/GeneralRegistration/General.vue";
export default {
  components: {
    General,
  },
};
</script>